// IMPORTs HERE
import { emailId } from "config";
import { GithubIcon, MailIcon, LinkedInIcon, InstagramIcon } from "assets/Images";

/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

export const socialProfiles = [
  {
    name: "Github",
    href: `https://github.com/parasagrawal71`,
    Icon: GithubIcon,
    newTab: true,
    hoverLabel: "Checkout my work on GitHub",
  },
  {
    name: "LinkedIn",
    href: `https://www.linkedin.com/in/parasagrawal71`,
    Icon: LinkedInIcon,
    newTab: true,
    hoverLabel: "Wanna hire me? Connect on LinkedIn",
  },
  {
    name: "Instagram",
    href: `https://www.instagram.com/paras__fbg`,
    Icon: InstagramIcon,
    newTab: true,
    hoverLabel: "Follow my journey on Instagram",
  },
  {
    name: "Mail",
    href: `mailto:${emailId}`,
    Icon: MailIcon,
    hoverLabel: "Drop me a message",
  },
];
